import RedactionPanel from './RedactionPanelContainer';

export default RedactionPanel;